import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';

const Cart = () => {
    const { cartItems, removeFromCart, updateQuantity, getTotalItems, getTotalPrice, clearCart } = useCart();

    if (cartItems.length === 0) {
        return (
            <section className="wrapper style1">
                <div className="container">
                    <div style={{ textAlign: 'center', padding: '50px 0' }}>
                        <h2 style={{
                            fontSize: '2rem',
                            fontWeight: 'bold',
                            color: '#000000',
                            margin: '0 0 20px 0'
                        }}>
                            Seu carrinho está vazio
                        </h2>
                        <p style={{
                            fontSize: '1.1rem',
                            color: '#666',
                            margin: '0 0 30px 0'
                        }}>
                            Que tal adicionar alguns produtos incríveis?
                        </p>
                        <Link
                            to="/"
                            style={{
                                display: 'inline-block',
                                padding: '15px 30px',
                                backgroundColor: '#edf507',
                                color: '#000000',
                                textDecoration: 'none',
                                borderRadius: '6px',
                                fontSize: '1.1rem',
                                fontWeight: 'bold',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#dce406';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#edf507';
                            }}
                        >
                            Continuar Comprando
                        </Link>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="wrapper style1">
            <div className="container">
                <h1 style={{
                    fontSize: '2.5rem',
                    fontWeight: 'bold',
                    color: '#000000',
                    margin: '0 0 30px 0',
                    textAlign: 'center'
                }}>
                    Carrinho de Compras
                </h1>

                <div className="row gtr-200">
                    <div className="col-8 col-12-narrower">
                        {/* Lista de produtos */}
                        {cartItems.map((item) => (
                            <div key={item.id} style={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #e0e0e0',
                                borderRadius: '8px',
                                padding: '20px',
                                margin: '0 0 20px 0',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '20px'
                            }}>
                                {/* Imagem do produto */}
                                <div style={{
                                    width: '100px',
                                    height: '100px',
                                    borderRadius: '6px',
                                    overflow: 'hidden',
                                    flexShrink: 0
                                }}>
                                    <img
                                        src={item.image}
                                        alt={item.alt}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                </div>

                                {/* Informações do produto */}
                                <div style={{ flex: '1' }}>
                                    <h3 style={{
                                        fontSize: '1.3rem',
                                        fontWeight: 'bold',
                                        color: '#000000',
                                        margin: '0 0 10px 0'
                                    }}>
                                        {item.title}
                                    </h3>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                        {/* Controle de quantidade */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <button
                                                onClick={() => updateQuantity(item.id, item.quantity - 1)}
                                                style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    backgroundColor: '#f8f8f8',
                                                    border: '2px solid #e0e0e0',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    fontSize: '1.1rem',
                                                    fontWeight: 'bold',
                                                    color: '#000000',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = '#e0e0e0';
                                                    e.target.style.borderColor = '#ccc';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = '#f8f8f8';
                                                    e.target.style.borderColor = '#e0e0e0';
                                                }}
                                            >
                                                −
                                            </button>
                                            <span style={{
                                                fontSize: '1.1rem',
                                                fontWeight: 'bold',
                                                minWidth: '40px',
                                                textAlign: 'center',
                                                backgroundColor: '#f8f8f8',
                                                border: '2px solid #e0e0e0',
                                                borderRadius: '6px',
                                                padding: '6px 8px',
                                                color: '#000000'
                                            }}>
                                                {item.quantity}
                                            </span>
                                            <button
                                                onClick={() => updateQuantity(item.id, item.quantity + 1)}
                                                style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    backgroundColor: '#f8f8f8',
                                                    border: '2px solid #e0e0e0',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    fontSize: '1.1rem',
                                                    fontWeight: 'bold',
                                                    color: '#000000',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = '#e0e0e0';
                                                    e.target.style.borderColor = '#ccc';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = '#f8f8f8';
                                                    e.target.style.borderColor = '#e0e0e0';
                                                }}
                                            >
                                                +
                                            </button>
                                        </div>

                                        {/* Preço unitário */}
                                        <div style={{
                                            fontSize: '1.1rem',
                                            fontWeight: 'bold',
                                            color: '#000000'
                                        }}>
                                            R$ {(item.currentPrice || 0).toFixed(2).replace('.', ',')}
                                        </div>
                                    </div>
                                </div>

                                {/* Preço total e botão remover */}
                                <div style={{ textAlign: 'right' }}>
                                    <div style={{
                                        fontSize: '1.3rem',
                                        fontWeight: 'bold',
                                        color: '#000000',
                                        margin: '0 0 10px 0'
                                    }}>
                                        R$ {((item.currentPrice || 0) * item.quantity).toFixed(2).replace('.', ',')}
                                    </div>
                                    <button
                                        onClick={() => removeFromCart(item.id)}
                                        style={{
                                            padding: '5px 10px',
                                            backgroundColor: '#ff4444',
                                            color: '#ffffff',
                                            border: 'none',
                                            borderRadius: '4px',
                                            fontSize: '0.9rem',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Remover
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Resumo do pedido */}
                    <div className="col-4 col-12-narrower">
                        <div style={{
                            backgroundColor: '#f8f8f8',
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            padding: '20px',
                            position: 'sticky',
                            top: '20px'
                        }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: 'bold',
                                color: '#000000',
                                margin: '0 0 20px 0',
                                textAlign: 'center'
                            }}>
                                Resumo do Pedido
                            </h3>

                            <div style={{ marginBottom: '20px' }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '10px'
                                }}>
                                    <span>Subtotal ({getTotalItems()} itens):</span>
                                    <span>R$ {(getTotalPrice() || 0).toFixed(2).replace('.', ',')}</span>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '10px'
                                }}>
                                    <span>Frete:</span>
                                    <span style={{ color: '#666' }}>A calcular</span>
                                </div>
                                <hr style={{ border: '1px solid #e0e0e0', margin: '15px 0' }} />
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    fontSize: '1.2rem',
                                    fontWeight: 'bold'
                                }}>
                                    <span>Total:</span>
                                    <span>R$ {(getTotalPrice() || 0).toFixed(2).replace('.', ',')}</span>
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <Link
                                    to="/checkout"
                                    style={{
                                        display: 'block',
                                        width: '100%',
                                        padding: '15px',
                                        backgroundColor: '#000000',
                                        color: '#ffffff',
                                        border: 'none',
                                        borderRadius: '6px',
                                        fontSize: '1.1rem',
                                        fontWeight: 'bold',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        textDecoration: 'none',
                                        textAlign: 'center'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#333333';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#000000';
                                    }}
                                >
                                    Finalizar Compra
                                </Link>

                                <button
                                    onClick={clearCart}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        backgroundColor: '#f0f0f0',
                                        color: '#666',
                                        border: '1px solid #ccc',
                                        borderRadius: '6px',
                                        fontSize: '1rem',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Limpar Carrinho
                                </button>

                                <Link
                                    to="/"
                                    style={{
                                        display: 'block',
                                        textAlign: 'center',
                                        padding: '10px',
                                        color: '#edf507',
                                        textDecoration: 'none',
                                        fontSize: '1rem'
                                    }}
                                >
                                    Continuar Comprando
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Cart;
